// api/request.js
import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
    // baseURL: 'https://tiktoktf.darknight.games/api', // 与 main.js 中的配置保持一致
    baseURL: 'https://tiktoktf.darknight.games/api',
    withCredentials: true, // 跨域请求时携带 cookies
    timeout: 300000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // advertiser_id 由调用方在请求时传入，不再自动从 localStorage 获取
        return config
    },
    error => {
        // 对请求错误做些什么
        console.error('Request error:', error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        const res = response.data
        console.log('Response:', res)
        // 特殊错误码：40911（重复文件名）需要由业务层处理，不在这里拦截
        if (res.code === 40911) {
            return res
        }

        // 如果返回的状态码不是 200 或 0，说明接口有错误
        if (res.code !== 0 && res.code !== 200 && res.code !== undefined) {
            // 可以根据需要处理错误码
            return Promise.reject(new Error(res.message || 'Error'))
        }
        return res
    },
    error => {
        // 对响应错误做点什么
        console.error('Response error:', error)
        return Promise.reject(error)
    }
)


export default service
